<template>
  <div
    class="p-3 my-2 shadow-sm animate__animated animate__fadeIn animate__faster position-relative"
    :class="showTable ? '' : 'customer'"
    style="border: 1px solid lightgray; border-radius: 5px;">
    <!-- Customer Section -->
    <div
      class="float-start cust-title"
      style="cursor: pointer; line-height: 18px;"
      @click="toggleTable">
      <div>
        {{customer.name}} ({{ customer.id }})
      </div>
      <div
        class="text-muted"
        style="font-size: 12px;">
        <span>
          {{ customer.address1 }}
        </span>
        <span v-if="customer.address2">
          , {{ customer.address2 }}
        </span>
        <span>
          , {{ customer.city }}
        </span>
        <span>
          , {{ customer.state_code }}
        </span>
        <span>
          {{ customer.zip_code }}
        </span>
      </div>
    </div>
    <span
      class="float-end text-muted"
      style="position: absolute; right: 1em; top: 15px;">
      ({{ customerRecords.length }})
      <i
        class="fa"
        :class="showTable ? 'fa-chevron-up' : 'fa-chevron-down'"
        style="cursor: pointer;"
        @click="toggleTable"/>
    </span>
    <div class="clearfix"/>
    <!-- Customer Records -->
    <div v-if="showTable">
      <button
        class="btn btn-sm btn-primary my-2 float-end"
        @click="setCustomer">
        View Details
      </button>
      <table class="table table-striped table-bordered mt-3 animate__animated animate__fadeIn animate__faster">
        <tbody>
          <Row
            v-for="r in customerRecords"
            :key="r"
            :record="r"
            :customer="customer"
            :item="itemMatch(r.merchandisingItemId, items)"/>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
  import Row from './Row.vue';
  import { itemMatch } from '../../js/displayTracking';
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['customer', 'records', 'items'])
  const store = useStore()

  // Data
  const showTable = ref(false)

  // Methods
  const toggleTable = ()=>{
    showTable.value = !showTable.value
  }

  const setCustomer = ()=>{
    store.dispatch('displayTrackingSetCustomer', props.customer)
  }

  // Computed
  const customerRecords = computed(()=>{
    return _.filter(props.records, r=> r.customerId == props.customer.id)
  })

</script>

<style scoped>
  .customer{
    min-height: 3em;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media(max-width: 525px){
    .cust-title{
      max-width: 60vw;
    }
  }
</style>